import React, { useEffect } from 'react';
import { useAwaitControl } from 'react-redux-await-control';

import { listReturnsParati } from '~/store/proposals/actions';

import { NoData } from '~/components/ContractReturns/Returns.styled';
import { ReturnsRefreshButton } from '~/components/ContractReturns/ReturnsRefreshButton';
import { PreProposalsTable } from './PreProposals/PreProposalsTable';
import { AccountTable } from './Account/AccountTable';
import { ProposalsTable } from './Proposals/ProposalsTable';

export type ParatiReturnsProps = {
  contractId: number | string;
  loan?: string;
};

export function ParatiReturns({ contractId, loan }: ParatiReturnsProps) {
  const listReturnsParatiControl = useAwaitControl(listReturnsParati);
  const { paratiAccount, paratiPreProposals, paratiProposals } = listReturnsParatiControl.result(contractId);

  useEffect(() => {
    listReturnsParatiControl.start({ contractId }, { actionId: contractId });
  }, [contractId]);

  const isEmpty = !paratiAccount && !paratiPreProposals?.length && !paratiProposals?.length;

  return (
    <>
      <ReturnsRefreshButton action={listReturnsParati} payload={{ contractId }} contractId={contractId} />
      {isEmpty ? (
        <NoData>
          <p>Nenhum retorno encontrado</p>
        </NoData>
      ) : (
        <>
          <AccountTable contractId={contractId} />
          <PreProposalsTable contractId={contractId} />
          <ProposalsTable contractId={contractId} loan={loan} />
        </>
      )}
    </>
  );
}
